import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDateFormat implements BaseEnumType {
  private static allValues: EnumDateFormat[] = []; // make sure this is top-most
  
  public static yYYYMMDD = new EnumDateFormat(0, "YYYYMMDD", "enum_date_format_y_y_y_y_m_m_d_d");
  public static dDMMYYYY = new EnumDateFormat(1, "DDMMYYYY", "enum_date_format_d_d_m_m_y_y_y_y");
  public static dDMMYY = new EnumDateFormat(2, "DDMMYY", "enum_date_format_d_d_m_m_y_y");
  public static mMDDYYYY = new EnumDateFormat(3, "MMDDYYYY", "enum_date_format_m_m_d_d_y_y_y_y");
  public static mMDDYY = new EnumDateFormat(4, "MMDDYY", "enum_date_format_m_m_d_d_y_y");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDateFormat.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isYYYYMMDD() { return this === EnumDateFormat.yYYYMMDD; }
  public isDDMMYYYY() { return this === EnumDateFormat.dDMMYYYY; }
  public isDDMMYY() { return this === EnumDateFormat.dDMMYY; }
  public isMMDDYYYY() { return this === EnumDateFormat.mMDDYYYY; }
  public isMMDDYY() { return this === EnumDateFormat.mMDDYY; }

  public static getValues(): readonly EnumDateFormat[] {
    return EnumDateFormat.allValues;
  }

  public static getValuesExcept0(): readonly EnumDateFormat[] {
    return EnumDateFormat.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDateFormat {
    const found = EnumDateFormat.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDateFormat - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDateFormat): EnumDateFormat {
    const found = name ? EnumDateFormat.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDateFormat - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDateFormat>): boolean {
    return this.key === other?.key;
  }
}